import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Type } from "class-transformer";
import { FileDto } from "@/core/features/file/file.dto";

export class TemplateDto extends BaseEntityDto {
  name: string;

  description?: string | null;

  @Type(() => FileDto)
  file: FileDto;

  fileId: string;
}
